<pux-cloak v-if="loading" :msg="'_TXT_BERICHT_DETAILS_LOADING_'"></pux-cloak><div v-else><component :is="report.tab_bericht" :report="report"></component></div>